import { IExpressionEvaluator } from "../../Models/IExpressionEvaluator";
import { MaybePromise } from "../../Models/MaybePromise";
import { IExpressionEvaluatorContext } from "../../Models/IExpressionEvaluatorContext";
import { WhenExpression } from "../../Models/WhenExpression";

export class WhenExpressionEvaluator implements IExpressionEvaluator<WhenExpression> {
  get type(): string {
    return "When";
  }

  evaluate(expression: WhenExpression, context: IExpressionEvaluatorContext): MaybePromise {
    const conditionResult = expression.Condition ? context.Evaluator.evaluate(expression.Condition, context) : true;

    if (conditionResult instanceof Promise) {
      return conditionResult.then((resolvedCondition) => {
        if (resolvedCondition) {
          return context.Evaluator.evaluate(expression.Value, context);
        }
        return undefined;
      });
    }

    if (conditionResult) {
      return context.Evaluator.evaluate(expression.Value, context);
    }
    return undefined;
  }
}
